import { HttpLink } from '@apollo/client'

import { DATOCMS_ENDPOINT } from 'Constants/Ids'

export function createDatoLink() {
  const httpLink = new HttpLink({ uri: DATOCMS_ENDPOINT.MAIN })

  return httpLink
}
